module.exports = __webpack_public_path__ + "static/media/circle-orange.832ac375.svg";